import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
  selector: "app-online-status-indicator",
  standalone: true,
  imports: [],
  templateUrl: "./online-status-indicator.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineStatusIndicatorComponent {
  @Input({required: true}) isOnline!: boolean;
  @Input() showLabel: boolean = true;
  @Input() size: 'small' | 'normal' = 'normal';
}
